import script from "./BroadcastRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastRoom.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastRoom.vue?vue&type=style&index=0&id=fa5e0728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa5e0728"]])

export default __exports__